"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Button.scss");
function IconButton({ customClass, disabled, onClick, children, isSecondary, datacy, isTertiary }) {
    const onHandleClick = (e) => {
        if (onClick) {
            e.stopPropagation();
            onClick();
        }
    };
    return (react_1.default.createElement("button", { "data-cy": datacy, disabled: disabled, className: `btn icon-btn ${customClass ? customClass : ''} ${disabled ? 'disabled' : ''} ${isSecondary ? 'secondary' : ''} ${isTertiary ? 'tertiary' : ''}`, onClick: onHandleClick }, children));
}
IconButton.defaultProps = {
    customClass: '',
    disabled: false,
    onClick: () => undefined,
    isSecondary: false,
    datacy: '',
    isTertiary: false
};
exports.default = IconButton;
